import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useHelmet } from '@agro-club/agroclub-shared'

import isLangSelect from 'helpers/isLangSelect'
import { I18nLangSelect } from 'views/components/I18nLangSelect/I18nLangSelect'

import { useAnalyticsIdentify } from 'analytics/hooks'
import { AuthContext } from 'modules/context/AuthContext'
import { useLocation, useNavigate } from 'react-router'
import styled from 'styled-components'
import { defaultRoute } from 'views/components/MainMenu/Options/CommonOptions'
import APageWrapper from 'views/components/PageWrapper/APageWrapper'
import { AnalyticsPages, AnalyticsPlaces } from './analyticsPlaces'
import { AuthLayout } from './AuthLayout'
import OtpForm from './OtpForm'
import PhoneForm, { requestCode } from './PhoneForm'

const FormMargin = styled.div`
  margin-top: 51px;
  width: 100%;
`
enum AuthSteps {
  PhoneInput = 'PhoneInput',
  OtpInput = 'OtpInput',
}

function AuthPage() {
  const { profile } = useContext(AuthContext)
  const [phone, setPhone] = useState('')
  const [ndaSigned, setNdaSigned] = useState(false)
  const location = useLocation()

  const { t } = useTranslation(['auth'])
  const navigate = useNavigate()
  useHelmet({ title: t('metaTitle') })

  const [step, setStep] = useState(AuthSteps.PhoneInput)

  const { userIdentification } = useAnalyticsIdentify()

  useEffect(() => {
    if (profile) {
      userIdentification(profile.id)
      navigate(location.state?.from || defaultRoute, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile])

  const onPhoneSent = (phone: string, ndaSigned: boolean) => {
    setNdaSigned(ndaSigned)
    setPhone(phone)
    setStep(AuthSteps.OtpInput)
  }

  const renderStep = () => {
    switch (step) {
      case AuthSteps.PhoneInput:
        return <PhoneForm onSuccess={onPhoneSent} />
      case AuthSteps.OtpInput:
        return (
          <OtpForm
            ndaSigned={ndaSigned}
            resend={() => requestCode({ phone })}
            phone={phone}
            onBack={() => setStep(AuthSteps.PhoneInput)}
          />
        )
      default:
        return null
    }
  }

  return (
    <>
      <APageWrapper page={AnalyticsPages.LOGIN} place={AnalyticsPlaces.LOGIN.PAGE}>
        <AuthLayout>
          <FormMargin>{renderStep()}</FormMargin>
        </AuthLayout>
      </APageWrapper>

      {isLangSelect() && (
        <div style={{ position: 'absolute', bottom: 8, left: 8 }}>
          <I18nLangSelect />
        </div>
      )}
    </>
  )
}

export default AuthPage
